export var ENV_IOS = 'iOS';
export var ENV_ANDROID = 'Android';
export var COIN_PAY = 'coin_v3';